import React from "react";
import aboutImage from "../../src/assets/waving.png"; // ← Twoja ilustracja

const AboutUsBlock = () => {
  return (
    <section
      id="about"
      style={{
        padding: "5rem 1rem",
        background: "#fff",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          maxWidth: "1100px",
          width: "100%",
          flexWrap: "wrap",
          gap: "2rem",
        }}
      >
        {/* LEWA STRONA – ILUSTRACJA */}
        <div style={{ flex: "1 1 45%", minWidth: "280px" }}>
          <img
            src={aboutImage}
            alt="Ilustracja o nas"
            style={{ width: "100%", maxWidth: "420px" }}
          />
        </div>

        {/* PRAWA STRONA – TEKST */}
        <div style={{ flex: "1 1 45%", minWidth: "280px", color: "#2E186A" }}>
          <h2 style={{ fontSize: "4em", marginBottom: "1.5rem" }}>O nas</h2>
          

          <p style={{ fontSize: "1.8rem", marginBottom: "1.5rem", color: "#2E186A", fontWeight: 500 }}>
            Ilona Kozłowska
          </p>
          <p style={{ fontWeight: 600, marginBottom: "1rem" }}>
            Założycielka AIgineer Club
          </p>

         

          <p style={{ fontSize: "1.4rem", marginBottom: "0.6em", fontWeight:300}}>
            Technik informatyk, absolwentka studiów z zakresu geoinformacji,
            edukatorka i mama. Tworzy przestrzeń, w której dzieci uczą się
            nowoczesnych technologii z radością i zrozumieniem. Wierzy, że każde
            dziecko zasługuje na przyjazny start w świat sztucznej inteligencji.
            „Jako mama wiem, jak ważne jest, by dziecko czuło się pewnie i
            bezpiecznie. Dlatego stworzyłam miejsce, w którym technologia staje
            się naprawdę dziecięca – bliska, zrozumiała i inspirująca.”
          </p>
          <p style={{ fontSize: "1.8rem", marginTop: "6rem", color: "#2E186A", fontWeight: 500 }}>
            Kacper Kozłowski
          </p>
          <p style={{ fontWeight: 600, marginBottom: "1rem" }}>
            Programista i mentor technologiczny
          </p>

         

          <p style={{ fontSize: "1.4rem", marginBottom: "02em", fontWeight:300}}>
            inżynier automatyki i robotyki, który dziś rozwija swoją karierę jako programista. W AIgineer Club pełni rolę technologicznego wsparcia – to on dba, by narzędzia działały, a innowacyjne pomysły można było zamienić w rzeczywistość. Łączy doświadczenie inżyniera z cierpliwością, humorem i pasją – bo wierzy, że technologia nie tylko zmienia świat, ale może być też świetną zabawą.
            </p>
        </div>

        
        
      </div>
    </section>
  );
};

export default AboutUsBlock;
